module.exports = __webpack_public_path__ + "b3bb2f8ba3cba4f749357a2b60fd2212.svg";